import React from 'react';
import HeaderBuyStep from "../buySteps/HeaderBuyStep";
import AddCommentBox from "./AddCommentBox";

const AddComment = () => {
    return (
        <div className="add-comment-wrapper" id="add-comment-toggle">
            <HeaderBuyStep/>
            <div className="add-comment">
            <AddCommentBox/>
            </div>
        </div>
    );
};

export default AddComment;
